import React from "react";
import CategoryFiltersPage from "./CategoryFiltersPage";
import CollectionFiltersPage from "./CollectionFiltersPage";
import LicenseFiltersPage from "./LicenseFiltersPage";

type FilterContentProps = {
  activeNavigation: any;
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?:any
  activeFilters?:any
};

const FilterContent: React.FC<FilterContentProps> = ({
  activeNavigation,
  setProductList,
  productList,
  // handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
}) => {
  if (!activeNavigation) return null;

  switch (activeNavigation.text) {
    case "Categories":
      return (
        <CategoryFiltersPage
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "Collections":
      return (
        <CollectionFiltersPage
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "License":
      return (
        <LicenseFiltersPage
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    default:
      return null;
  }
};

export default FilterContent;
